import { useTranslation } from "react-i18next";
import ZeitonHeroLaptop from "../../Images/ZeitonHeroLaptop.png";
import AboutZeitonPhoto from "../../Images/AboutZeiton.png";
import { Helmet } from "react-helmet-async";
import { Typography, Dialog, Button } from "@material-tailwind/react";
import ZeitonFeaturesComponent from "../FeatureComponents/ZeitonFeaturesComponent";
import PricesComponent from "../Prices/PricesComponent";
import ZeitonTryDemoComponent from "../TryDemo/ZeitonTryDemoComponent";
import ZeitonFAQsComponent from "../FAQs/ZeitonFAQsComponent";
import ZeitonFeaturesDetailed from "../FeatureComponents/ZeitonFeaturesDetailedComponent";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../app/store";
import { useNavigate } from "react-router-dom";
import { AssignDemoLicense } from "../../features/Licenses/licensesSlice";
import SuccessCard from "../../features/CommonPages/successCard";
import { useState } from "react";
import tryDemoBg from "../../Images/ZeitonTryDemoLowerBg.png";

const applicationName = "ZEITON"

export function ZeitonPage() {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const accountData = useSelector((state: RootState) => state.AccountSlice);
    const [disabledButtonAfterSuccess, setDisabledButtonAfterSuccess] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(true);
    const handleOpenDialog = () => { setOpenDialog(!openDialog); }

    function ZeitonHero() {
        return (
            <div className="flex flex-col xl:flex-row">
                <div className="w-[270px] md:w-[500px] xl:w-[750px] h-[175px] md:h-fit overflow-hidden flex flex-shrink-0">
                    {/* Background circle */}
                    <div className="w-[99px] md:w-[153px] h-[98px] md:h-[157px] md:translate-y-[80px] xl:translate-y-[150px] bg-[#FF7C46] rounded-full flex-shrink-0"></div>

                    {/* Glass card */}
                    <div className="relative flex-shrink-0 w-[257px] md:w-[calc(100%-33px)] h-[150px] md:h-[250px] xl:h-[320px] -translate-x-[86px] md:-translate-x-[125px] translate-y-[22px] md:translate-y-0 z-10">

                        {/* BLUR LAYER */}
                        <div className="absolute inset-0 bg-[#FF61041A] backdrop-blur-2xl border border-white/30 rounded-2xl will-change-[backdrop-filter] translate-z-0"></div>

                        {/* CONTENT LAYER */}
                        <div className="relative flex flex-col items-center justify-start pt-4 xl:pt-8 gap-4 md:gap-8 text-center h-full">
                            <h1 className="text-[#1E1E1E] text-2xl md:text-5xl xl:text-[54px] font-bold mt-3 md:mt-5 xl:mt-3">
                                ZEITON
                            </h1>
                            <p className="text-[#1E1E1E] text-sm md:text-2xl xl:text-4xl px-3 font-bold">
                                {t("ZEITON_MAIN_DESCRIPTION")}
                            </p>
                            <Button id="tryDemoHeroBigBtn" onClick={handleTryDemoClick} disabled={disabledButtonAfterSuccess} className="uppercase hidden xl:flex text-[#1E1E1E] hover:bg-[#FF7C46] bg-#FF9800 rounded-[25px] h-[40px] px-[50px] text-sm font-bold shadow-none hover:shadow-none justify-center items-center">
                                {t("TryDemo")}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="z-30 -translate-y-[15px] xl:translate-y-[-65px] w-full flex items-center justify-between md:justify-end">
                    <Button id="tryDemoHeroSmallBtn" onClick={handleTryDemoClick} disabled={disabledButtonAfterSuccess} className="uppercase xl:hidden text-[#1E1E1E] hover:bg-[#FF7C46] bg-#FF9800 rounded-[25px] h-[40px] px-[25px] md:px-[50px] text-sm font-bold shadow-none hover:shadow-none flex justify-center items-center">
                        {t("TryDemo")}
                    </Button>
                    <img src={ZeitonHeroLaptop} alt="Zeiton Hero" className="xl:hidden z-30 w-[150px] md:w-[250px] object-contain" />
                </div>
                <img src={ZeitonHeroLaptop} alt="Zeiton Hero" className="hidden xl:block z-30 w-[200px] xl:w-[360px] 2xl:w-[400px] object-contain -translate-x-20 translate-y-24" />
            </div>
        )
    }

    function AboutZeiton() {
        return (
            <div className="w-full grid grid-cols-1 xl:grid-cols-2 xl:gap-[80px] xl:justify-between mb-[30px] xl:my-[50px]">
                <div className="mx-[20%] xl:mx-0 xl:pl-[20%] flex flex-col justify-center">
                    <Typography variant="h2" className="uppercase font-bold text-lg 2xl:text-2xl text-left py-[20px] xl:py-0 xl:pb-[20px] tracking-[5%]">
                        {t("AboutZeiton")}
                    </Typography>
                    <div className="flex items-center">
                        <div className="hidden xl:block h-[90%] w-5 bg-[#3BA6B7] mr-[30px] mx-auto" />
                        <div className="flex flex-col gap-[20px]">
                            <Typography variant="h2" className="text-base 2xl:text-xl font-normal tracking-[5%]">
                                {t("AboutZeitonText")}
                            </Typography>
                            <Typography variant="h2" className="text-base 2xl:text-xl font-normal tracking-[5%]">
                                {t("AboutZeitonTextSecond")}
                            </Typography>
                        </div>
                    </div>
                </div>
                <div className="hidden xl:block mr-0 ml-auto ">
                    <img src={AboutZeitonPhoto} alt="tgaBackground" className="h-full w-auto max-w-[370px] sm:max-w-[470px] lg:max-w-[670px] xl:max-w-[520px] 2xl:max-w-[670px] " />
                </div>
            </div>
        )
    }

    const zeitonUrl = "https://zeiton.bimagine.com/";

    const AccessZeitonClick = () => {
        window.open(zeitonUrl, '_blank', "noopener,noreferrer");
    }

    function AccessZeiton() {
        return (
            <div className="px-[25px] xl:px-[100px] relative w-full flex justify-center bg-#F6F6F6">
                <img src={tryDemoBg} alt="TryDemoLowerBg" className="object-cover h-full min-h-[130px] w-full rounded-br-[22px] rounded-bl-[22px]" />
                <div className="absolute inset-0 flex flex-col-reverse xl:flex-row justify-center items-center gap-4 px-[30px]">
                    <Button id="viewDocumentationBtn" onClick={AccessZeitonClick} className="bg-#FF8136 text-#161616 shadow-none hover:bg-#FF9800 hover:shadow-none rounded-[25px] h-[40px] px-[50px] text-sm font-bold flex justify-center items-center">
                        {t("Access")} Zeiton
                    </Button>
                    <Typography className="text-#282828 font-medium text-[12px] xl:text-[14px] 2xl:text-[18px] leading-[12px] xl:leading-[16px] 2xl:leading-[18px] xl:max-w-[450px] 2xl:max-w-none text-center">
                        {t("AccessZeitonDescription")}
                    </Typography>
                    <hr className="bg-#282828 w-[1px] hidden xl:block xl:py-[30px]" />
                    <Typography className="uppercase text-#282828 font-semibold text-[14px] md:text-[16px] xl:text-[20px] 2xl:text-[26px] leading-[16px] xl:leading-[20px] 2xl:leading-[24px]">
                        ZEITON {t("Platform")}
                    </Typography>
                </div>
            </div>
        )
    }

    function handleTryDemoClick(): void {
        if (disabledButtonAfterSuccess) return;
        if (!accountData.hasUserData) {
            navigate('/login');
        }
        else
            dispatch(AssignDemoLicense(applicationName)).unwrap().then(() => {
                setSuccess(true);
                setMessage(t("DemoLicenseAssigned"))
                handleOpenDialog();
                setDisabledButtonAfterSuccess(true);

            }).catch(() => {
                setSuccess(false);
                setMessage(t("DemoLicenseAssignError"))
                handleOpenDialog();
            });
    }

    return (
        <>
            <Helmet>
                <title>ZEITON</title>
                <meta name="description" content="Zeiton is a powerful time management tool that empowers project and department leaders to plan, track, and manage resources effectively. It streamlines workflows, improves team collaboration, and provides real-time insights to support data-driven decision-making." />
                <link rel="canonical" href={"https://www.bimagine.com/productsPage/zeiton"} />
            </Helmet>
            <div className="bg-#F6F6F6">
                <div className="pt-[20px] xl:py-[100px] px-[20px] md:px-[50px] 2xl:px-[100px] flex justify-center xl:bg-[#ECECEC]">
                    <ZeitonHero />
                </div>
                <AboutZeiton />
                <ZeitonFeaturesComponent />
                <ZeitonFeaturesDetailed />
                <PricesComponent familyTypeValue="ZEITON" />
                <div className="flex items-center my-[30px] lg:my-[60px]">
                    <hr className="flex-grow h-px bg-#A0A0A0" />
                    <div className="mx-5 text-#333333 text-base font-medium uppercase">{t("Or")}</div>
                    <hr className="flex-grow h-px bg-#A0A0A0" />
                </div>
                <ZeitonTryDemoComponent onTryDemoClickFunction={handleTryDemoClick} isButtonDisabled={disabledButtonAfterSuccess} />
                <AccessZeiton />
                <ZeitonFAQsComponent />

                <Dialog open={openDialog} handler={handleOpenDialog} size="xs" animate={{ mount: { scale: 1, y: 0 }, unmount: { scale: 0.9, y: -100 } }}>
                    <SuccessCard onClickFunction={handleOpenDialog} text={message} success={success} />
                </Dialog>
            </div>
        </>
    );
}